(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-split"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.rzSplitNotifyReady) return;
    window.rzSplitNotifyReady = true;

    const getModal = (trigger) => {
      const root = trigger.closest('[data-rz-split-notify-root]');
      return root ? document.getElementById(root.dataset.rzSplitNotifyModalId) : null;
    };

    const open = (trigger) => {
      const modal = getModal(trigger);
      if (!modal) return;
      const tags = modal.querySelector('[data-rz-split-notify-tags]');
      const copy = modal.querySelector('[data-rz-split-notify-copy]');
      const input = modal.querySelector('input[type="email"]');
      if (tags) tags.value = trigger.dataset.rzSplitNotifyTags || '';
      if (copy) copy.textContent = trigger.dataset.rzSplitNotifyTitle || '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      if (input) input.focus();
    };

    const close = (modal) => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-rz-split-notify-trigger]');
      if (trigger) {
        event.preventDefault();
        open(trigger);
        return;
      }

      const closer = event.target.closest('[data-rz-split-notify-close]');
      const modal = closer && closer.closest('[data-rz-split-notify-modal]');
      if (modal) close(modal);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-rz-split-notify-modal]:not([hidden])').forEach(close);
    });

    document.querySelectorAll('[data-rz-split-notify-state="posted"]').forEach((state) => {
      const modal = state.closest('[data-rz-split-notify-modal]');
      if (!modal) return;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
